import { Component, Input } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";

@Component({
  selector: "edp-header-pack",
  templateUrl: "./edp-header-pack.component.html",
  styleUrls: ["./edp-header-pack.component.scss"]
})
export class EdpHeaderPackComponent {
    @Input() set contractSelected(contract: Contract) {
        this.contract = contract;
        this.pack = contract.getPackProperties(contract.HasPack);
    }
    public pack;
    public contract: Contract;

}
